<form
  novalidate
  [action]="genericFormFields.action"
  [target]="genericFormFields.target"
  [method]="genericFormFields.method"
  #genericRedirectForm
>
  <input
    *ngFor="let item of genericFormFields.fieldItem"
    value="{{ item.value }}"
    hidden
    name="{{ item.key }}"
  />
</form>
